export default function contactFormCheck() {
  let errorElm = document.getElementsByClassName("js-must");

  for( let i = 0 ; i < errorElm.length ; i ++ ) {
    if(errorElm[i].querySelector(".error")) {
      errorElm[i].classList.add("js-error")
    }
  }
}